import { useEffect } from "react";

export default function useClickOutside(ref, callback) {
    useEffect(() => {

        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                // Відкладено: інакше закриття на mousedown зміщує layout до click — кнопки в main не отримують click.
                setTimeout(() => callback(), 0);
            }
        };

        document.addEventListener("mousedown", handleClick);
        document.addEventListener("touchstart", handleClick); // 👈 важно для мобилки

        return () => {
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("touchstart", handleClick);
        };

    }, [ref, callback]);
}